import type { IAdaptReport } from '~/types/shared-types'
import { ESecondCategoriesIds } from '@/domains/investor/const/SecondCategories.enum'
import { EMainCategoriesNIds } from '@/domains/investor/const/MainCategories.enum'

import type { IProps as IHeroProps } from '@/domains/investor/components/Hero/Hero.types'
export const useMapToHero = (data: IAdaptReport) : IHeroProps => {
  const { t, locale } = useI18n()
  const localePath = useLocalePath()

  const HERO_DATA = {
    [EMainCategoriesNIds.REPORT]: {
      mainCategory: {
        label: t('investor.hero.report.mainCategory.label'),
        url: localePath({name: 'investor'}, locale.value),
        aria: t('investor.hero.report.mainCategory.aria'),
      },
      header: t('investor.hero.report.header'),
      image: '/images/investor/report/article/hero.png',
      button: {
        text: t('investor.hero.report.button1.label'),
        to: t('investor.hero.report.button1.to'),
      },
    },
    [EMainCategoriesNIds.PRESENTATION]: {
      mainCategory: {
        label: t('investor.hero.presentation.mainCategory.label'),
        url: localePath({name: 'investor-assembly'}, locale.value),
        aria: t('investor.hero.presentation.mainCategory.aria'),
      },
      header: t('investor.hero.presentation.header'),
      image: '/images/investor/hero/walne-zgromadzenie.png',
      button: {
        text: t('investor.hero.presentation.button1.label'),
        to: t('investor.hero.presentation.button1.to'),
      },
    },
  }

  const isGeneralMeeting = data.mappedMainCategory === EMainCategoriesNIds.PRESENTATION
    && data.mappedSecondCategories.some((category) => [ESecondCategoriesIds.EXTRAORDINARY_ASSEMBLY, ESecondCategoriesIds.ORDINARY_ASSEMBLY].includes(category))

  const heroData = HERO_DATA[isGeneralMeeting ? EMainCategoriesNIds.PRESENTATION : EMainCategoriesNIds.REPORT]

  const SECONDARY_CATEGORIES = {
    [ESecondCategoriesIds.YEAR_REPORT]: {
      label: t('investor.hero.report.secondCategory.yearReport.label'),
      url: `#${t('investor.article.id')}`,
      aria: t('investor.hero.report.secondCategory.yearReport.aria'),
    },
    [ESecondCategoriesIds.HALF_YEAR_REPORT]: {
      label: t('investor.hero.report.secondCategory.halfYearReport.label'),
      url: `#${t('investor.article.id')}`,
      aria: t('investor.hero.report.secondCategory.halfYearReport.aria'),
    },
    [ESecondCategoriesIds.QUARTER_REPORT]: {
      label: t('investor.hero.report.secondCategory.quarterReport.label'),
      url: `#${t('investor.article.id')}`,
      aria: t('investor.hero.report.secondCategory.quarterReport.aria'),
    },
    [ESecondCategoriesIds.CURRENT_REPORT]: {
      label: t('investor.hero.report.secondCategory.currentReport.label'),
      url: `#${t('investor.article.id')}`,
      aria: t('investor.hero.report.secondCategory.currentReport.aria'),
    },
    [ESecondCategoriesIds.ARCHIVE]: {
      label: t('investor.hero.report.secondCategory.archive.label'),
      url: `#${t('investor.article.id')}`,
      aria: t('investor.hero.report.secondCategory.archive.aria'),
    },
    [ESecondCategoriesIds.EXTRAORDINARY_ASSEMBLY]: {
      label: t('investor.hero.presentation.secondCategory.extraOrdinaryAssembly.label'),
      url: `#${t('investor.article.id')}`,
      aria: t('investor.hero.report.secondCategory.extraOrdinaryAssembly.aria'),
    },
    [ESecondCategoriesIds.ORDINARY_ASSEMBLY]: {
      label: t('investor.hero.presentation.secondCategory.ordinaryAssembly.label'),
      url: `#${t('investor.article.id')}`,
      aria: t('investor.hero.report.secondCategory.ordinaryAssembly.aria'),
    },
  }

  const mappedSecondCategories = data.mappedSecondCategories.map((category) => SECONDARY_CATEGORIES[category as unknown as ESecondCategoriesIds])

  return {
    mainCategory: heroData.mainCategory,
    lead: data.title,
    // when there is more than one categories, pick second category
    secondCategory: mappedSecondCategories[1] ? mappedSecondCategories[1] : mappedSecondCategories[0],
    title: heroData.header,
    image: heroData.image,
    firstButton: heroData.button,
  }
}
